import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../v3/Common/Token';
import { AllInsurancesUrl, bankDetailsUrl, beneficiaryNomineeURL, beneficiaryUrl,getBeneficiaryNomineeUrl,getPanCardImageUrl,InsuranceDetailsUrl, NomineeRelationURL, nomineeUrl, updateRelationUrl } from '../url';
import { createActionErrorCapture, errorEnvelope } from '../../../../../utils/sentryUtils';

// PWA-reachable module: capture at the action layer so failures carry a stack
// trace and an error kind, not just a message string from the call site.
const captureActionError = createActionErrorCapture('beneficiary');

export const getAllInsurances  = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${AllInsurancesUrl()}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getAllInsurances');
        return next(errorEnvelope(err));
      });
  });
};
export const getInsuranceDetails  = async (insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${InsuranceDetailsUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getInsuranceDetails');
        return next(errorEnvelope(err));
      });
  });
};
export const getNomineeRelatioAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${NomineeRelationURL()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getNomineeRelatioAction');
        return next(errorEnvelope(err));
      });
  });
};

export const getBankDetails  = async (insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${bankDetailsUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getBankDetails');
        return next(errorEnvelope(err));
      });
  });
};
export const getBeneficiaryNomineeDetails  = async (insuranceType, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getBeneficiaryNomineeUrl()}?insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getBeneficiaryNomineeDetails');
        return next(errorEnvelope(err));
      });
  });
};
export const getPancardImageAction  = async (beneficiary_id, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getPanCardImageUrl()}/${beneficiary_id}?company_esi_id=${company_esi_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getPancardImageAction');
        return next(errorEnvelope(err));
      });
  });
};

export const getUpdatedReationAction  = async (firm_type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${updateRelationUrl()}?firm_type=${firm_type}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'getUpdatedReationAction');
        return next(errorEnvelope(err));
      });
  });
};


// Add actions [POST]
export const AddBeneficiaryAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${beneficiaryUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'AddBeneficiaryAction');
        // FIXME(PLAT-10998): next() is never called here, so this promise never
        // settles and the caller's await hangs forever. Left as-is deliberately —
        // fixing it changes user-visible flow and belongs in its own change.
        return err;
      });
  });
};
export const AddBeneficiaryNomineeAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${beneficiaryNomineeURL()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'AddBeneficiaryNomineeAction');
        // FIXME(PLAT-10998): next() is never called here, so this promise never
        // settles and the caller's await hangs forever. Left as-is deliberately —
        // fixing it changes user-visible flow and belongs in its own change.
        return err;
      });
  });
};
export const AddBankDetailsAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${bankDetailsUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'AddBankDetailsAction');
        // FIXME(PLAT-10998): next() is never called here, so this promise never
        // settles and the caller's await hangs forever. Left as-is deliberately —
        // fixing it changes user-visible flow and belongs in its own change.
        return err;
      });
  });
};


// Delete actions [DELETE]
export const deleteBeneficiaryAction = async (beneficiary_id, insuranceType, company_esi_id) => {
    return new Promise(async (next) => {
      let token = await getToken();
      await axios
        .delete(
          `${beneficiaryUrl()}?beneficiary_id=${beneficiary_id}&insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`,
          getTokenHeader(token),
        )
        .then(async ({ data }) => {
          return next(data);
        })
        .catch((err) => {
          captureActionError(err, 'deleteBeneficiaryAction');
          return next(errorEnvelope(err));
        });
    });
};
export const deleteNomineeAction = async (beneficiary_id, nominee_id, insuranceType, company_esi_id) => {
    return new Promise(async (next) => {
      let token = await getToken();
      await axios
        .delete(
          `${nomineeUrl()}?beneficiary_id=${beneficiary_id}&nominee_id=${nominee_id}&insurance_type=${insuranceType}&company_esi_id=${company_esi_id}`,
          getTokenHeader(token),
        )
        .then(async ({ data }) => {
          return next(data);
        })
        .catch((err) => {
          captureActionError(err, 'deleteNomineeAction');
          return next(errorEnvelope(err));
        });
    });
};

// Update actions [PATCH]
export const updateBankDetailsAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .patch(bankDetailsUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        captureActionError(err, 'updateBankDetailsAction');
        // FIXME(PLAT-10998): next() is never called here, so this promise never
        // settles and the caller's await hangs forever. Left as-is deliberately —
        // fixing it changes user-visible flow and belongs in its own change.
        return err;
      });
  });
};


